<template>
  <div class="space-y-8">
    <!-- Tabla -->
    <div class="mt-2 hidden lg:block" v-for="(factura, index) in facturas" :key="index">
      <div
        class="min-w-full overflow-hidden overflow-x-auto align-middle shadow ring-1 ring-gray-200 sm:rounded-t-lg"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th
                class="bg-blue-400 px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-white"
              >
                Factura {{ factura.factura.factura_codigo.trim().toUpperCase() }}
                {{ factura.factura.factura_numero }}
              </th>

              <th
                class="bg-blue-400 px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-white"
              >
                Fecha
                {{ getMomentDate(factura.factura.fecha) | date('America/Buenos_Aires', 'DD-MM-Y') }}
              </th>

              <th
                class="bg-blue-400 px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-white"
              >
                Delegación {{ factura.sede.descripcion }}
              </th>

              <th
                class="bg-blue-400 px-4 py-2 text-right text-xs font-medium uppercase tracking-wider text-white"
              >
                Monto {{ factura.factura.total | currency }}
              </th>
            </tr>
          </thead>

          <!-- <tbody class="bg-white divide-y divide-gray-200">
            <tr class="bg-white">
              <td class="px-4 py-2 text-sm text-left text-gray-500 whitespace-nowrap">
                {{ getMomentDate(factura.factura.fecha) | date('America/Buenos_Aires', 'DD-MM-Y') }}
              </td>

              <td class="px-4 py-2 text-sm text-left text-gray-500 whitespace-nowrap">
                {{ factura.factura.factura_codigo.trim().toUpperCase() }} {{ factura.factura.factura_numero }}
              </td>

              <td class="px-4 py-2 text-sm text-left text-gray-500 whitespace-nowrap">
                {{ factura.sede.descripcion }}
              </td>

              <td class="px-4 py-2 text-sm text-right text-gray-500 whitespace-nowrap">
                {{ factura.factura.total | currency }}
              </td>
            </tr>
          </tbody> -->
        </table>
      </div>
      <div
        class="min-w-full overflow-hidden overflow-x-auto align-middle shadow ring-1 ring-gray-200 sm:rounded-b-lg"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th
                class="bg-gray-50 px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Nro. comprobante
              </th>

              <th
                class="bg-gray-50 px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Estado al uso
              </th>

              <th
                class="bg-gray-50 px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Fecha de uso
              </th>

              <th
                class="bg-gray-50 px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Estado actual
              </th>

              <th
                class="bg-gray-50 px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Fecha estado actual
              </th>

              <th
                class="bg-gray-50 px-4 py-1 text-right text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Monto
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-200 bg-white">
            <tr v-for="(comprobante, index) in factura.comprobantes" :key="index" class="bg-white">
              <td class="whitespace-nowrap px-4 py-2 text-left text-sm text-gray-500">
                {{ comprobante.comprobante.numero_comprobante }}
              </td>

              <td class="whitespace-nowrap px-4 py-2 text-left text-sm text-gray-500">
                {{ textoEstadoPago(comprobante.pago_al_usar.estado_id) }}
              </td>

              <td class="whitespace-nowrap px-4 py-2 text-left text-sm text-gray-500">
                {{ getMomentDate(comprobante.uso.fecha) | date('America/Buenos_Aires', 'DD-MM-Y') }}
              </td>

              <td class="whitespace-nowrap px-4 py-2 text-left text-sm text-gray-500">
                {{ textoEstadoPago(comprobante.pago.estado_id) }}
              </td>

              <td class="whitespace-nowrap px-4 py-2 text-left text-sm text-gray-500">
                {{
                  getMomentDate(comprobante.pago.fecha) | date('America/Buenos_Aires', 'DD-MM-Y')
                }}
              </td>

              <td class="whitespace-nowrap px-4 py-2 text-right text-sm text-gray-500">
                {{ comprobante.comprobante.monto | currency }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Cards -->
    <div class="grid grid-cols-1 justify-center gap-6 lg:hidden">
      <div
        v-for="(factura, index) in facturas"
        :key="index"
        class="flex flex-col items-center justify-between rounded-lg border-2 border-gray-200 bg-white py-1"
      >
        <div>
          <p class="text-base font-bold tracking-wide text-gray-600">
            Factura {{ factura.factura.factura_codigo.trim().toUpperCase() }}
            {{ factura.factura.factura_numero }}
          </p>

          <p class="text-base tracking-wide text-gray-600">
            <span class="font-medium">Fecha:</span>
            {{ getMomentDate(factura.factura.fecha) | date('America/Buenos_Aires', 'DD-MM-Y') }}
          </p>

          <p class="text-base tracking-wide text-gray-600">
            <span class="font-medium">Delegación:</span> {{ factura.sede.descripcion }}
          </p>

          <p class="text-base tracking-wide text-gray-600">
            <span class="font-medium">Monto:</span> {{ factura.factura.total | currency }}
          </p>
        </div>

        <div class="pt-4 font-semibold text-gray-600">Comprobantes asociados</div>
        <div
          v-for="(comprobante, index) in factura.comprobantes"
          :key="index"
          class="grid grid-cols-1 gap-x-4 px-4 py-2 sm:w-full sm:grid-cols-5 sm:odd:bg-white sm:even:bg-gray-100"
        >
          <p class="whitespace-nowrap text-base text-gray-600 sm:col-span-3">
            <span class="font-medium">Nro. comprobante:</span>
            {{ comprobante.comprobante.numero_comprobante }}
          </p>
          <p class="whitespace-nowrap text-base text-gray-600 sm:col-span-2">
            <span class="font-medium">Estado al uso:</span>
            {{ textoEstadoPago(comprobante.pago_al_usar.estado_id) }}
          </p>

          <p class="whitespace-nowrap text-base text-gray-600 sm:col-span-3">
            <span class="font-medium">Fecha de uso:</span>
            {{ getMomentDate(comprobante.uso.fecha) | date('America/Buenos_Aires', 'DD-MM-Y') }}
          </p>

          <p class="whitespace-nowrap text-base text-gray-600 sm:col-span-2">
            <span class="font-medium">Estado actual:</span>
            {{ textoEstadoPago(comprobante.pago.estado_id) }}
          </p>

          <p class="whitespace-nowrap text-base text-gray-600 sm:col-span-3">
            <span class="font-medium">Fecha estado actual:</span>
            {{ getMomentDate(comprobante.pago.fecha) | date('America/Buenos_Aires', 'DD-MM-Y') }}
          </p>

          <p class="whitespace-nowrap text-base text-gray-600 sm:col-span-2">
            <span class="font-medium">Monto:</span> {{ comprobante.comprobante.monto | currency }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

import { useSession } from '@colescba/ui'

export default {
  props: ['facturas'],

  mixins: [useSession()],

  computed: {
    ...mapState({
      estadosPago: state => state.app.estadosPago,
    }),
  },

  methods: {
    getMomentDate(date) {
      return moment(date, 'DD-MM-YYYY')
    },
    textoEstadoPago(estadoId) {
      return this.estadosPago?.find(e => e.id.trim() == estadoId).descripcion
    },
  },
}
</script>
